// extracted by mini-css-extract-plugin
export default {"error-message":"Gifts_error-message__YhXYe"};